import colors from "theme/colors.module.scss";
import shadows from "theme/shadows.module.scss";
import borders from "theme/borders.module.scss";

const theme = {
    token: {
        fontFamily: "'Monrope', sans-serif",
        colorPrimary: colors.primaryPurple500,
        colorText: colors.black,
        colorBgTextHover: "transparent",
        colorBgContainer: colors.primaryBackground,
        boxShadowSecondary: shadows.primaryShadow,
        borderRadiusLG: borders.borderRadiusSM
    },
    components: {
        Button: {
            fontWeight: 700,
            textTextColor: colors.text500,
            textTextHoverColor: colors.text400,
            textTextActiveColor: colors.primaryPurple500,
            textHoverBg: colors.translucentPurple,
            defaultActiveBg: colors.translucentPurple,
        },
        Card: {
            actionsBg: colors.primaryBackground,
        },
        Modal: {
            contentBg: colors.primaryBackground,
            headerBg: colors.primaryBackground,
            footerBg: colors.primaryBackground,
        }
    }
};
export default theme;
